import { AxiosResponse } from 'axios';
import api from './Api'

export const getDosanProgramMember = (): Promise<AxiosResponse<IDosanProgramMember, any>> => {
    return api.get(`/dosan/program/member`);
}